export interface AppLoaderOptionsModel {
  message?: string;
  title?: string;
  type?: 'modal' | 'popup';
}
